import React from "react";
import { Box, Typography } from "@mui/material";
import { MONO_FONT, useMetricsUi } from "./metricsUi";

/**
 * Shared analysis-page header shell (visual only).
 * Canonical layout established by Sales Analysis:
 * [badge] [title] [optional client pill] ........ [right controls]
 */
const AnalysisPageTopbar = ({ badge, title, clientName, right, mb = 2.5 }) => {
  const ui = useMetricsUi();
  const { colors } = ui;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        alignItems: "center",
        justifyContent: "space-between",
        mb,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: "9px",
            background: `linear-gradient(155deg, ${ui.accent}, #1B3FA8)`,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            fontSize: 13,
            fontFamily: MONO_FONT,
            flexShrink: 0,
            letterSpacing: "0.02em",
          }}
        >
          {badge}
        </Box>
        <Typography
          sx={{
            fontSize: 15,
            fontWeight: 700,
            color: colors.textPrimary,
            lineHeight: 1,
          }}
        >
          {title}
          {clientName ? (
            <Box
              component="span"
              sx={{
                ml: 1,
                fontSize: 11,
                fontWeight: 700,
                color: ui.accent,
                backgroundColor: ui.accentSoft,
                borderRadius: "20px",
                px: 1.1,
                py: 0.3,
                verticalAlign: "middle",
              }}
            >
              {clientName}
            </Box>
          ) : null}
        </Typography>
      </Box>

      {right ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1.5,
            alignItems: "center",
          }}
        >
          {right}
        </Box>
      ) : null}
    </Box>
  );
};

export default AnalysisPageTopbar;
